module.exports = __webpack_public_path__ + "static/media/homepage-hero1.b5cfd1f9.png";